import {$qsAll} from '../../../../@shared/ts/dom';
import {type ModalPage, type LoadingMode} from '../../models/IEnvironment';
import {DefaultCart} from '../../reducers/cartReducer';
import {Environment} from '../../reducers/environmentReducer';
import {PaymentConfiguration} from '../../reducers/paymentConfigurationReducer';
import {store} from '../../store';
import {formatCurrencyString} from '../../util/currency';
import {getLocaleText} from '../../util/translation';

function setupPoyntButton() {
	store.subscribe(() => {
		renderPoyntButtonDisplay(
			PaymentConfiguration.selectedGateway(),
			Environment.modalUI.page(),
			Environment.modalUI.loadingMode(),
		);

		renderPoyntButtonLoading(
			Environment.modalUI.loadingMode(),
		);
	});
}

function renderPoyntButtonDisplay(gatewayId: string, page: ModalPage, loadingMode: LoadingMode) {
	// Show/hide poynt button container
	if (gatewayId.startsWith('peachpay_poynt_') && page === 'payment') {
		$qsAll('.poynt-btn-container', $element => {
			$element.classList.remove('hide');
		});
	} else {
		$qsAll('.poynt-btn-container', $element => {
			$element.classList.add('hide');
		});
	}

	// Hide/Show button
	if (loadingMode === 'loading') {
		$qsAll('.poynt-btn', $element => {
			$element.classList.add('hide');
		});
	} else {
		$qsAll('.poynt-btn', $element => {
			$element.classList.remove('hide');
		});
	}
}

function renderPoyntButtonLoading(mode: LoadingMode) {
	// Show/hide the external spinner
	if (mode === 'loading') {
		$qsAll('.poynt-spinner-container', $element => {
			$element.classList.remove('hide');
		});
	} else {
		$qsAll('.poynt-spinner-container', $element => {
			$element.classList.add('hide');
		});
	}

	// Show/hide the internal spinner
	if (mode === 'processing') {
		$qsAll('.poynt-btn-spinner', $element => {
			$element.classList.remove('hide');
		});
	} else {
		$qsAll('.poynt-btn-spinner', $element => {
			$element.classList.add('hide');
		});
	}

	// Show/hide processing message
	if (mode === 'processing') {
		$qsAll('.poynt-btn > .button-text', $element => {
			$element.innerHTML = getLocaleText('Processing');
		});
	} else {
		$qsAll('.poynt-btn > .button-text', $element => {
			$element.innerHTML = `${getLocaleText('Pay')} ${formatCurrencyString(DefaultCart.total())}`;
		});
	}

	// Enable/disable the poynt button
	if (mode === 'finished') {
		$qsAll<HTMLInputElement>('.poynt-btn', $element => {
			$element.disabled = false;
		});
	} else {
		$qsAll<HTMLInputElement>('.poynt-btn', $element => {
			$element.disabled = true;
		});
	}
}

export {setupPoyntButton};
